<template>
	<section role="main" class="content-body">
		<header class="page-header">
			<h2>意見反映</h2>
			<div class="right-wrapper">
				<ol class="breadcrumbs">
					<li>
						<router-link to="/">
							<i class="fa fa-home"></i>
						</router-link>
					</li>
					<li>意見反映</li>
				</ol>
			</div>
		</header>
		<main>
			<section class="panel panel-default" style="margin-bottom: 0px;">
				<header class="panel-heading" style="padding: 10px;">
					<div class="panel-actions" style="top: 7px;">
						<a href="#searchArea" data-toggle="collapse" class="panel-action panel-action-toggle"></a>
					</div>
					<h4 class="panel-title">&emsp;</h4>
				</header>
				<div class="tab-content">
					<div class="tab-pane fade in show" role="tabpanel" aria-labelledby="vacation-tab">
						<div class="row form-group">
							<div class="col-md-6">
								<label class="col-md-4">姓　　名</label>
								<div class="col-md-8">{{stuData.name}}</div>
							</div>
							<div class="col-md-6">
								<label class="col-md-4">電　　話</label>
								<div class="col-md-8">{{stuData.phone}}</div>
							</div>
						</div>
						<div class="row form-group">
							<div class="col-md-12">
								<label class="col-md-2">意見反映</label>
								<div class="col-md-10">
									<textarea rows="5" class="form-control" v-model="opinionBack.opinion" :disabled="sessionData.accountType != 'STU'"></textarea>
								</div>
								
							</div>
						</div>
						<div class="row form-group">
							<div class="col-md-offset-5 col-md-2 form-group">
								<a v-if="sessionData.accountType == 'STU'" @click="saveOpinion" class="btn btn-primary btn-block">送出</a>
								<a v-else @click="clickPrevious" class="btn btn-primary btn-block">返回</a>
							</div>
						</div>
					</div>

				</div>
			</section>
		</main>
	</section>
</template>
<script>
export default {
	data(){
		return {
			stuData:{},
			opinionBack:{
				account:"",
				smtr:"",
				opinion:""
			}
		}
	},
	props:["account"],
	mounted(){
		this.smtr = this.nowSmtr;
		if(this.getStore(this.$route.name)){
			let s = JSON.parse(this.getStore(this.$route.name));
			this.opinionBack.account = s.account;
			this.opinionBack.opinion = s.opinion;
		}
		const api = `/api/TenancyOpinionBack/stuData/${this.opinionBack.account}`;
		this.$axios.post(api).then(resp =>{
			this.stuData = resp.data.data;
		});
	},
	methods:{
		saveOpinion(){
			let _this = this;
			if(!this.opinionBack.opinion){
				bootbox.alert("請填寫反應意見");
				return false;
			}
			if(this.opinionBack.opinion.length > 500){
				bootbox.alert("意見反映字數不可超過500字");
				return false;
			}
			const api = `/api/TenancyOpinionBack/saveOpinionBack`;
			this.$axios.post(api, JSON.stringify(this.opinionBack)).then(resp =>{
				bootbox.alert(resp.data.msg, function(){
					if(resp.data.status == "success"){
						_this.$router.go(-1);
					}
				});
			});

		},
		clickPrevious() {
			this.$router.go(-1)
		},
	},
	beforeRouteLeave(to, from, next) {
		this.removeStore(this.$route.name);
		next();
	}
}
</script>